import { render, staticRenderFns } from "./Baujahr.vue?vue&type=template&id=bd456ca2"
import script from "./Baujahr.vue?vue&type=script&lang=js"
export * from "./Baujahr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports